// api

import { useEffect } from 'react';
import { LoadingView } from '../../../components';
import { RELATION_TYPE, useGetRelationsInByIdQuery } from '../../../services/objects';
import { FlexGridView } from '../Grid/FlexGridView';
import { AutomationObjectCard } from '../Grid/AutomationObjectCard';



export function RelationsInViewGrid(props: { parentId: string, relationType: keyof typeof RELATION_TYPE, resourceGroupId: string, children?: any, refetchCnt?: number | undefined, flexGridColumnCount?: any }) {

    const { data: nodesIn, isLoading, isSuccess, error, isFetching, refetch } = useGetRelationsInByIdQuery({ objectId: props.parentId, type: props.relationType, resourceGroupId: props.resourceGroupId }, { skip: !props.parentId });

    useEffect(() => {
        if (!isLoading && !isFetching) {
            setTimeout(async () => { await refetch(); }, 3000);
        }
    }, [props.refetchCnt])

    return (
        <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
            <FlexGridView flexGridColumnCount={props.flexGridColumnCount} >
                {nodesIn?.map((item: any, index: number) => (
                    <AutomationObjectCard key={item.id} item={item}></AutomationObjectCard>
                ))}
                {props.children}
            </FlexGridView>
        </LoadingView>
    )
}
